import { availableNetworks, selectableNetworks } from '@polkadot/networks';

const CRYPTOS = [
  {
    info: "sr25519",
    text: "Schnorrkel (sr25519, recommended)",
    value: "sr25519"
  },
  {
    info: "ed25519",
    text: "Edwards (ed25519, alternative)",
    value: "ed25519"
  },
  {
    info: "ecdsa",
    text: "ECDSA (Non BTC/ETH compatible)",
    value: "ecdsa"
  }
];
const CRYPTOS_ETH = [
  {
    info: "ethereum",
    text: "ECDSA (ETH compatible)",
    value: "ethereum"
  }
];
const CRYPTOS_LEDGER = [
  ...CRYPTOS,
  {
    info: "ed25519-ledger",
    text: "Ledger (ed25519, BIP32 derivation)",
    value: "ed25519-ledger"
  }
];

const KUSAMA_ENDPOINTS = [
  {
    info: "kusama",
    text: "Kusama (Parity)",
    value: "wss://kusama-rpc.polkadot.io"
  },
  {
    info: "kusama",
    text: "Kusama (RadiumBlock)",
    value: "wss://kusama.public.curie.radiumblock.co/ws"
  },
  {
    info: "kusama",
    text: "Kusama (IBP-GeoDNS1)",
    value: "wss://rpc.ibp.network/kusama"
  },
  {
    info: "kusama",
    text: "Kusama (IBP-GeoDNS2)",
    value: "wss://rpc.dotters.network/kusama"
  },
  {
    info: "kusama",
    text: "Kusama (Automata 1RPC)",
    value: "wss://1rpc.io/ksm"
  },
  {
    info: "kusama",
    text: "Kusama (OnFinality)",
    value: "wss://kusama.api.onfinality.io/public-ws"
  },
  {
    info: "kusama",
    text: "Kusama (Dwellir)",
    value: "wss://kusama-rpc.dwellir.com"
  }
];
const POLKADOT_ENDPOINTS = [
  {
    info: "polkadot",
    text: "Polkadot (Parity)",
    value: "wss://rpc.polkadot.io"
  },
  {
    info: "polkadot",
    text: "Polkadot (RadiumBlock)",
    value: "wss://polkadot.public.curie.radiumblock.co/ws"
  },
  {
    info: "polkadot",
    text: "Polkadot (IBP-GeoDNS1)",
    value: "wss://rpc.ibp.network/polkadot"
  },
  {
    info: "polkadot",
    text: "Polkadot (IBP-GeoDNS2)",
    value: "wss://rpc.dotters.network/polkadot"
  },
  {
    info: "polkadot",
    text: "Polkadot (Automata 1RPC)",
    value: "wss://1rpc.io/dot"
  },
  {
    info: "polkadot",
    text: "Polkadot (OnFinality)",
    value: "wss://polkadot.api.onfinality.io/public-ws"
  },
  {
    info: "polkadot",
    text: "Polkadot (Dwellir)",
    value: "wss://polkadot-rpc.dwellir.com"
  }
];
const STATEMINT_ENDPOINTS = [
  {
    info: "statemint",
    text: "Statemint (Parity)",
    value: "wss://statemint-rpc.polkadot.io"
  },
  {
    info: "statemint",
    text: "Statemint (IBP-GeoDNS1)",
    value: "wss://rpc.ibp.network/statemint"
  },
  {
    info: "statemint",
    text: "Statemint (IBP-GeoDNS2)",
    value: "wss://rpc.dotters.network/statemint"
  },
  {
    info: "statemint",
    text: "Statemint (OnFinality)",
    value: "wss://statemint.api.onfinality.io/public-ws"
  },
  {
    info: "statemint",
    text: "Statemint (Dwellir)",
    value: "wss://statemint-rpc.dwellir.com"
  }
];
const ENDPOINTS = [
  {
    info: "basilisk",
    text: "Basilisk (Dwellir)",
    value: "wss://basilisk-rpc.dwellir.com"
  },
  {
    info: "basilisk",
    text: "Basilisk (HydraDX)",
    value: "wss://rpc.basilisk.cloud"
  },
  ...KUSAMA_ENDPOINTS,
  ...KUSAMA_ENDPOINTS.map(({ info: _info, ...rest }) => ({
    info: "rmrk",
    ...rest
  })),
  {
    info: "statemine",
    text: "Statemine (Parity)",
    value: "wss://statemine-rpc.polkadot.io"
  },
  {
    info: "statemine",
    text: "Statemine (OnFinality)",
    value: "wss://statemine.api.onfinality.io/public-ws"
  },
  {
    info: "statemine",
    text: "Statemine (RadiumBlock)",
    value: "wss://statemine.api.onfinality.io/public-ws"
  },
  {
    info: "statemine",
    text: "Statemine (RadiumBlock)",
    value: "wss://statemine.api.onfinality.io/public-ws"
  },
  ...POLKADOT_ENDPOINTS,
  ...STATEMINT_ENDPOINTS,
  {
    info: "snek",
    text: "Snek Rococo (HydraDX)",
    value: "wss://rococo-basilisk-rpc.hydration.dev"
  },
  {
    info: "moonriver",
    text: "Moonriver (Moonbeam)",
    value: "wss://wss.api.moonriver.moonbeam.network"
  },
  {
    info: "moonbeam",
    text: "Moonbeam (Moonbeam)",
    value: "wss://public-rpc.pinknode.io/moonbeam"
  },
  {
    info: "local",
    text: "Local Node (Own, 127.0.0.1:9944)",
    value: "ws://127.0.0.1:9944/"
  },
  {
    info: "parachain",
    text: "Local Parachain Node (Own, 127.0.0.1:9988)",
    value: "ws://127.0.0.1:9988/"
  }
];
const ENDPOINT_DEFAULT = KUSAMA_ENDPOINTS[0].value || "wss://kusama-rpc.polkadot.io";

const LEDGER_CONN_DEFAULT = "none";
const LEDGER_CONN = [
  {
    info: "none",
    text: "Do not attach Ledger devices",
    value: "none"
  },
  // Deprecated
  // {
  //   info: 'u2f',
  //   text: 'Attach Ledger via U2F',
  //   value: 'u2f'
  // },
  {
    info: "webusb",
    text: "Attach Ledger via WebUSB (Chrome, recommended)",
    value: "webusb"
  },
  {
    info: "hid",
    text: "Attach Ledger via WebHID (Chrome, experimental)",
    value: "hid"
  }
];

const PREFIX_DEFAULT$1 = -1;
const defaultNetwork = {
  info: "default",
  text: "Default for the connected node",
  value: -1
};
const networks = availableNetworks.map(({ displayName, network, prefix }) => ({
  info: network,
  text: displayName,
  value: prefix
}));
const PREFIXES$1 = [defaultNetwork, ...networks];

const INDEXERS = [
  {
    info: "kusama",
    text: "Kusama (rubick)",
    value: "https://squid.subsquid.io/rubick/graphql"
  },
  {
    info: "ksm",
    text: "RMRK2 (marck)",
    value: "https://squid.subsquid.io/marck/graphql"
  },
  {
    info: "basilisk",
    text: "Basilisk (snekk)",
    value: "https://squid.subsquid.io/snekk/v/005/graphql"
  },
  {
    info: "snek",
    text: "Snek (snekk)",
    value: "https://squid.subsquid.io/snekk/v/004/graphql"
  },
  {
    info: "statemine",
    text: "Statemine (stick)",
    value: "https://squid.subsquid.io/v/v1/graphql"
  },
  {
    info: "statemint",
    text: "Statemint (speck)",
    value: "https://squid.subsquid.io/speck/v/v1/graphql"
  },
  {
    info: "polkadot",
    text: "Polkadot (:4350)",
    value: "http://127.0.0.1:4350/graphql"
  },
  {
    info: "moonriver",
    text: "Moonbeam (antick)",
    value: "http://localhost:4350/graphql"
  },
  {
    info: "moonbeam",
    text: "Moonriver (click)",
    value: "http://localhost:4350/graphql"
  },
  {
    info: "local",
    text: "Local Indexer (:4350)",
    value: "http://127.0.0.1:4350/graphql"
  },
  {
    info: "local",
    text: "Local Indexer (:3000)",
    value: "http://127.0.0.1:3000"
  }
];
const INDEXER_DEFAULT = INDEXERS[0].value || "https://api.subquery.network/sq/vikiival/magick";

const PREFIX_DEFAULT = "ksm";
const PREFIXES = [
  {
    info: "basilisk",
    text: "Basilisk",
    value: "bsx"
  },
  {
    info: "kusama",
    text: "Kusama",
    value: "rmrk"
  },
  {
    info: "rmrk",
    text: "RMRK2",
    value: "ksm"
  },
  {
    info: "statemine",
    text: "Statemine",
    value: "stmn"
  },
  {
    info: "polkadot",
    text: "Polkadot",
    value: "dot"
  },
  {
    info: "statemint",
    text: "Statemint",
    value: "stt"
  },
  {
    info: "snek",
    text: "Snek [Rococo]",
    value: "snek"
  },
  {
    info: "moonriver",
    text: "Moonriver [Beta]",
    value: "movr"
  },
  {
    info: "moonbeam",
    text: "Moonbeam [Beta]",
    value: "glmr"
  }
];

const isPolkadot = typeof window !== "undefined" && window.location.host.includes("polkadot");

const PAGINATION_DEFAULT = "12";
const PAGINATIONS = [12, 24, 48].map((value) => ({ value, text: value.toString(), info: value.toString() }));
const DISPLAY_DEFAULT = "large";
const DISPLAYS = [
  {
    info: "large",
    text: "Large display",
    value: "large"
  },
  {
    info: "small",
    text: "Small display",
    value: "small"
  }
];
const SHOW_DEFAULT = "all";
const SHOW_OPTIONS = [
  {
    info: "all",
    text: "Show all",
    value: "large"
  },
  {
    info: "some",
    text: "Small display",
    value: "small"
  }
];
const UITHEME_DEFAULT = isPolkadot ? "polkadot" : "substrate";
const UITHEMES = [
  {
    info: "polkadot",
    text: "Polkadot",
    value: "polkadot"
  },
  {
    info: "substrate",
    text: "Substrate",
    value: "substrate"
  }
];
const CHANGE_DEFAULT = "auto";
const CHANGE_OPTIONS = [
  {
    info: "auto",
    text: "Automatic",
    value: "auto"
  },
  {
    info: "manual",
    text: "Manual (change node && indexer)",
    value: "manual"
  }
];
const ICON_DEFAULT = "default";
const ICON_DEFAULT_HOST = isPolkadot ? "polkadot" : "substrate";
const ICONS = [
  {
    info: "default",
    text: "Default for the connected node",
    value: "default"
  },
  {
    info: "polkadot",
    text: "Polkadot",
    value: "polkadot"
  },
  {
    info: "substrate",
    text: "Substrate",
    value: "substrate"
  },
  {
    info: "beachball",
    text: "Beachball",
    value: "beachball"
  }
];

const chains = selectableNetworks.filter(({ genesisHash }) => genesisHash.length > 1).reduce(
  (chains2, { genesisHash, network }) => ({
    ...chains2,
    [network]: genesisHash
  }),
  {}
);
const chains$1 = chains;

const CAMERA_DEFAULT = "off";
const CAMERA = [
  {
    info: "on",
    text: "Allow camera access",
    value: "on"
  },
  {
    info: "off",
    text: "Do not allow camera access",
    value: "off"
  }
];
const LANGUAGE_DEFAULT = "default";
const LOCKING_DEFAULT = "session";
const LOCKING = [
  {
    info: "session",
    text: "Once per session",
    value: "session"
  },
  {
    info: "tx",
    text: "On each transaction",
    value: "tx"
  }
];

const equalsOrLocal = (value) => (option) => option.info === value || option.info === "local";
const valueEquals = (value) => (option) => option.value === value;
const isAuto = (value) => value === "auto";

const avaibleOptions = {
  nodes: ENDPOINTS,
  cryptos: CRYPTOS,
  languages: [],
  locking: LOCKING,
  prefixes: PREFIXES$1,
  paginations: PAGINATIONS,
  displays: DISPLAYS,
  showOptions: SHOW_OPTIONS,
  uiThemes: UITHEMES,
  icons: ICONS,
  cameras: CAMERA,
  ledgers: LEDGER_CONN,
  urlPrefixes: PREFIXES,
  indexers: INDEXERS,
  changes: CHANGE_OPTIONS
};
const defaultState = {
  apiUrl: ENDPOINT_DEFAULT,
  camera: CAMERA_DEFAULT,
  ledgerConn: LEDGER_CONN_DEFAULT,
  i18nLang: LANGUAGE_DEFAULT,
  icon: ICON_DEFAULT,
  locking: LOCKING_DEFAULT,
  prefix: PREFIX_DEFAULT$1,
  pagination: PAGINATION_DEFAULT,
  display: DISPLAY_DEFAULT,
  show: SHOW_DEFAULT,
  uiTheme: UITHEME_DEFAULT,
  avaibleOptions,
  urlPrefix: PREFIX_DEFAULT,
  indexer: INDEXER_DEFAULT,
  change: CHANGE_DEFAULT
};
const SettingModule = {
  state: { ...defaultState },
  mutations: {
    setSettings(state, settings) {
      Object.keys(settings).forEach((key) => {
        state[key] = settings[key];
      });
    },
    createNode(state, nodeOption) {
      state.avaibleOptions.nodes = [...state.avaibleOptions.nodes, nodeOption];
    }
  },
  actions: {
    setSettings({ commit }, settings) {
      commit("setSettings", settings);
    },
    setApiUrl({ commit }, apiUrl) {
      commit("setSettings", { apiUrl });
    },
    setLanguage({ commit }, i18nLang) {
      commit("setSettings", { i18nLang });
    },
    setLocking({ commit }, locking) {
      commit("setSettings", { locking });
    },
    setPrefix({ commit }, prefix) {
      commit("setSettings", { prefix });
    },
    setUiTheme({ commit }, uiTheme) {
      commit("setSettings", { uiTheme });
    },
    setPagination({ commit }, pagination) {
      commit("setSettings", { pagination });
    },
    setDisplay({ commit }, display) {
      commit("setSettings", { display });
    },
    setShowOption({ commit }, show) {
      commit("setSettings", { show });
    },
    setUrlPrefix({ commit, state, dispatch }, urlPrefix) {
      commit("setSettings", { urlPrefix });
      if (isAuto(state.change)) {
        const valueOfPrefix = state.avaibleOptions.urlPrefixes.find(valueEquals(urlPrefix))?.info;
        const eq = equalsOrLocal(valueOfPrefix || urlPrefix);
        const apiUrl = state.avaibleOptions.nodes.find(eq)?.value;
        dispatch("setApiUrl", apiUrl);
        const indexer = state.avaibleOptions.indexers.find(eq)?.value;
        dispatch("setIndexer", indexer);
      }
    },
    setIndexer({ commit }, indexer) {
      commit("setSettings", { indexer });
    },
    setIcon({ commit }, icon) {
      commit("setSettings", { icon });
    },
    setChange({ commit }, change) {
      commit("setSettings", { change });
    },
    addNode({ commit }, nodeOption) {
      if (nodeOption.value && nodeOption.text) {
        commit("createNode", nodeOption);
      }
    }
  },
  getters: {
    availableUrlPrefixes(state) {
      return state.avaibleOptions.urlPrefixes;
    },
    availableIndexers(state) {
      return state.avaibleOptions.indexers;
    },
    availableNodes(state) {
      return state.avaibleOptions.nodes;
    },
    availableLanguages(state) {
      return state.avaibleOptions.languages;
    },
    availableCryptos(state) {
      return state.avaibleOptions.cryptos;
    },
    availableLocking(state) {
      return state.avaibleOptions.locking;
    },
    availablePrefixes(state) {
      return state.avaibleOptions.prefixes;
    },
    availablePaginations(state) {
      return state.avaibleOptions.paginations;
    },
    availableDisplays(state) {
      return state.avaibleOptions.displays;
    },
    availableShowOptions(state) {
      return state.avaibleOptions.showOptions;
    },
    availableUiThemes(state) {
      return state.avaibleOptions.uiThemes;
    },
    availableIcons(state) {
      return state.avaibleOptions.icons;
    },
    availableChanges(state) {
      return state.avaibleOptions.changes;
    },
    currentChainByPrefix(state) {
      return state.avaibleOptions.urlPrefixes.find(
        (prefix) => prefix.value === state.urlPrefix
      )?.info;
    },
    currentUrlPrefix(state) {
      return state.urlPrefix;
    },
    availableNodesByPrefix(_, getters) {
      const eq = equalsOrLocal(getters.currentChainByPrefix);
      return getters.availableNodes.filter(eq);
    },
    availableIndexerByPrefix(_, getters) {
      const eq = equalsOrLocal(getters.currentChainByPrefix);
      return getters.availableIndexers.filter(eq);
    },
    getSettings({ ...rest }) {
      return rest;
    }
  }
};
function Module(overrideDefault) {
  return {
    ...SettingModule,
    state: {
      ...SettingModule.state,
      ...overrideDefault
    }
  };
}
const SettingModule$1 = SettingModule;

export { CAMERA, CAMERA_DEFAULT, CHANGE_DEFAULT, CHANGE_OPTIONS, CRYPTOS, CRYPTOS_ETH, CRYPTOS_LEDGER, DISPLAYS, DISPLAY_DEFAULT, ENDPOINTS, ENDPOINT_DEFAULT, ICONS, ICON_DEFAULT, ICON_DEFAULT_HOST, INDEXERS, INDEXER_DEFAULT, LANGUAGE_DEFAULT, LEDGER_CONN, LEDGER_CONN_DEFAULT, LOCKING, LOCKING_DEFAULT, Module as OverrideSettingModule, PAGINATIONS, PAGINATION_DEFAULT, PREFIXES$1 as PREFIXES, PREFIX_DEFAULT$1 as PREFIX_DEFAULT, SHOW_DEFAULT, SHOW_OPTIONS, UITHEMES, UITHEME_DEFAULT, PREFIXES as URL_PREFIXES, PREFIX_DEFAULT as URL_PREFIX_DEFAULT, chains$1 as chains, SettingModule$1 as default };
